import LabelField from '@app/components/atoms/LabelField/LabelField'
import Autocomplete from '@mui/material/Autocomplete'
import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'
import { useTranslation } from 'react-i18next'

const PartnerSection = ({ register, errors, setValue, partners, trigger }) => {
  const { t } = useTranslation()
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <LabelField required title={t('CAMPAIGN.CHOOSE_PARTNER')}>
          <Autocomplete
            fullWidth
            getOptionLabel={(option) => option.name}
            id="tags-outlined"
            isOptionEqualToValue={(option, value) => option.id === value.id}
            options={partners}
            renderInput={(params) => (
              <TextField
                fullWidth
                {...params}
                size="small"
                variant="outlined"
                {...register('partner_id')}
                error={errors.partner_id}
                helperText={errors.partner_id?.message}
                onFocus={() => trigger('partner_id')}
              />
            )}
            size="small"
            {...register('partner_id')}
            onChange={(e, value) => {
              setValue('partner', value)
            }}
          />
        </LabelField>
      </Grid>
    </Grid>
  )
}
export default PartnerSection
